<template>
  <div class="recordSKU">
    <el-form
      class="custom-formScreen"
      :model="formScreen"
      ref="formScreen"
      label-width="100px"
      inline
    >
      <el-form-item>
        <el-button type="primary" @click="createdRecordSKU">新增</el-button>
      </el-form-item>
      <!-- S: 占位，不要删 -->
      <el-form-item></el-form-item>
      <el-form-item></el-form-item>
      <!-- E: 占位，不要删 -->
      <el-form-item prop="searchString" label=" " style="width: 40%">
        <el-input
          v-model="formScreen.searchString"
          placeholder="SKU、申报中文品名、申报英文品名"
          style="width: calc(100% - 140px);"
        ></el-input>
        <el-button type="primary" @click="searchForm" style="margin-left: 10px;">搜索</el-button>
        <el-button type="primary" @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="listTable" :header-cell-style="{ textAlign: 'center' }" border>
      <el-table-column prop="sku" label="SKU" align="center"></el-table-column>
      <el-table-column label="申报品名" align="center">
        <template slot-scope="scope">
          <div>英文：{{ scope.row.englishName }}</div>
          <div>中文：{{ scope.row.chinaName }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="purchasePrice" label="采购价" align="center"></el-table-column>
      <el-table-column label="图片" width="200" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.productImages">
            <el-popover
              trigger="hover"
              placement="right"
              prop="orderItems.imageUrl"
              v-if="scope.row.productImages[0]"
            >
              <el-image style="width: 500px;height: 500px;" :src="scope.row.productImages[0]" />
              <div class="scope_img" slot="reference">
                <el-image :src="scope.row.productImages[0]" />
              </div>
            </el-popover>
            <el-button
              type="text"
              size="mini"
              v-else
              @click="getOriginalImg(item)"
              style="padding: 0;"
            >查看原图</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="海关审核状态" align="center">
        <template slot-scope="scope">
          <div style="width: 130px;text-align: left;margin: 0 auto;">
            <span>北美：</span>
            <span v-if="scope.row.naStatus === 0">待审核</span>
            <span
              v-else-if="scope.row.naStatus === 1"
              :style="{color: scope.row.naStatus === 1 ? 'green' : ''}"
            >审核通过</span>
            <span
              v-else-if="scope.row.naStatus === 2"
              :style="{color: scope.row.naStatus === 2 ? 'red' : ''}"
            >审核不予通过</span>
          </div>
          <div style="width: 130px;text-align: left;margin: 0 auto;">
            <span>欧洲：</span>
            <span v-if="scope.row.eurStatus === 0">待审核</span>
            <span
              v-else-if="scope.row.eurStatus === 1"
              :style="{color: scope.row.eurStatus === 1 ? 'green' : ''}"
            >审核通过</span>
            <span
              v-else-if="scope.row.eurStatus === 2"
              :style="{color: scope.row.eurStatus === 2 ? 'red' : ''}"
            >审核不予通过</span>
          </div>
          <div style="width: 130px;text-align: left;margin: 0 auto;">
            <span>中国：</span>
            <span v-if="scope.row.zhStatus === 0">待审核</span>
            <span
              v-else-if="scope.row.zhStatus === 1"
              :style="{color: scope.row.zhStatus === 1 ? 'green' : ''}"
            >审核通过</span>
            <span
              v-else-if="scope.row.zhStatus === 2"
              :style="{color: scope.row.zhStatus === 2 ? 'red' : ''}"
            >审核不予通过</span>
          </div>
          <div style="width: 130px;text-align: left;margin: 0 auto;">
            <span>日本：</span>
            <span v-if="scope.row.jpStatus === 0">待审核</span>
            <span
              v-else-if="scope.row.jpStatus === 1"
              :style="{color: scope.row.jpStatus === 1 ? 'green' : ''}"
            >审核通过</span>
            <span
              v-else-if="scope.row.jpStatus === 2"
              :style="{color: scope.row.jpStatus === 2 ? 'red' : ''}"
            >审核不予通过</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button type="primary" @click="modifyRecordSKU(scope.row)">修改</el-button>
          <el-button type="danger" @click="deleteRecordSKU(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-box" type="flex" justify="center" align="middle">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100, 200, 300]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>
    <!-- S: 新增备案SKU -->
    <el-dialog width="40%" title="新增备案SKU" :visible.sync="dialogVisible" @close="dialogClose">
      <el-form
        class="formDialog"
        :model="formDialog"
        ref="formDialog"
        label-width="120px"
        label-position="left"
      >
        <template v-if="dialogType === 'created'">
          <el-form-item label="SKU" prop="sku">
            <el-input v-model="formDialog.sku" placeholder="仅支持填写一个SKU"></el-input>
          </el-form-item>
          <el-form-item label="申报英文品名" prop="englishName">
            <el-input v-model="formDialog.englishName"></el-input>
          </el-form-item>
          <el-form-item label="申报中文品名" prop="chinaName">
            <el-input v-model="formDialog.chinaName"></el-input>
          </el-form-item>
          <el-form-item label="采购价" prop="purchasePrice">
            <el-input v-model="formDialog.purchasePrice"></el-input>
          </el-form-item>
          <el-form-item label="海关审核状态"></el-form-item>
        </template>
        <el-form-item label="北美" prop="naStatus">
          <el-select v-model="formDialog.naStatus">
            <el-option
              v-for="item in listExamineType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="欧洲" prop="eurStatus">
          <el-select v-model="formDialog.eurStatus">
            <el-option
              v-for="item in listExamineType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="中国" prop="zhStatus">
          <el-select v-model="formDialog.zhStatus">
            <el-option
              v-for="item in listExamineType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日本" prop="jpStatus">
          <el-select v-model="formDialog.jpStatus">
            <el-option
              v-for="item in listExamineType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-if="dialogType === 'created'">
          <el-form-item label="产品图片">
            <el-upload
              list-type="picture-card"
              :multiple="true"
              :action="action"
              :headers="customHeaders"
              :on-success="handleSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
            >
              <i class="el-icon-plus" style="color: #0724ef;"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisibleImg" append-to-body>
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRocordSku" :loading="loadingStatus">确 定</el-button>
      </div>
    </el-dialog>
    <!-- E: 新增备案SKU -->
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
  name: 'RecordSKU',
  data() {
    return {
      action: Baseurl + "imageController/uploadImage",
      customHeaders: { token: localStorage.getItem("token") },
      // UserInfo: {},
      page: 1,
      size: 20,
      total: 0,
      formScreen: {
        searchString: ''
      },
      listTable: [],
      formDialog: {
        sku: "",
        chinaName: "",
        englishName: "",
        purchasePrice: "",
        naStatus: 0,
        eurStatus: 0,
        zhStatus: 0,
        jpStatus: 0
      },
      formModify: {},
      dialogType: 'created',
      dialogVisible: false,
      dialogImageUrl: '',
      dialogVisibleImg: false,
      listUploadImg: [],
      listExamineType: [
        { value: 0, label: '待审核' },
        { value: 1, label: '审核通过' },
        { value: 2, label: '审核不予通过' }
      ],
      loadingStatus: false
    }
  },
  created() {
    // this.UserInfo = JSON.parse(localStorage.getItem("role"));
    this.getListTable()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val;
      this.getListTable();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getListTable();
    },
    getListTable() {
      const API = Baseurl + 'recordSkuController/selectRecordSkuList'
      const paramsData = {
        page: this.page,
        size: this.size,
        searchString: this.formScreen.searchString
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listTable = data.list
          this.total = data.total
        }
      })
    },
    searchForm() {
      this.page = 1
      this.getListTable();
    },
    resetForm() {
      this.page = 1
      this.$refs.formScreen.resetFields();
      this.getListTable();
    },
    dialogClose() {
      this.listUploadImg = []
      this.formDialog = this.$options.data().formDialog
      this.dialogVisibleImg = false
    },
    createdRecordSKU() {
      this.dialogType = 'created'
      this.dialogVisible = true
    },
    modifyRecordSKU(row) {
      this.dialogType = 'modify'
      this.formModify = row
      this.formDialog.naStatus = row.naStatus
      this.formDialog.eurStatus = row.eurStatus
      this.formDialog.zhStatus = row.zhStatus
      this.formDialog.jpStatus = row.jpStatus
      this.dialogVisible = true
    },
    submitRocordSku() {
      const API = Baseurl + 'recordSkuController/insertOrUpdateRecordSku'
      const productImages = this.listUploadImg.map(item => item.response.data)
      const templateObj = {
        id: this.formModify.id,
        naStatus: this.formDialog.naStatus,
        eurStatus: this.formDialog.eurStatus,
        zhStatus: this.formDialog.zhStatus,
        jpStatus: this.formDialog.jpStatus
      }
      let paramsData = this.dialogType === 'created' ? { productImages, ...this.formDialog } : templateObj
      this.loadingStatus = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingStatus = false
        const { code, data } = res.data
        if (code === 200) {
          this.dialogVisible = false
          this.getListTable()
          this.$message.success('操作成功')
        } else {
          this.$message.error('操作失败')
        }
      })
    },
    async deleteRecordSKU(row) {
      try {
        await this.$confirm('确认要删除吗？', '提示')
        const API = Baseurl + 'recordSkuController/deleteRecordSku'
        const paramsData = { id: row.id }
        ajaxPost(API, paramsData).then(res => {
          const { code, data } = res.data
          if (code === 200) {
            this.dialogVisible = false
            this.getListTable()
            this.$message.success('操作成功')
          }
        })
      } catch (error) {
        const tips = error === 'cancel' ? '取消操作' : error
        this.$message(tips)
      }
    },
    handleSuccess(response, file, fileList) {
      this.listUploadImg = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleImg = true;
    },
    handleRemove(file, fileList) {
      this.listUploadImg = fileList
    },
  }
}
</script>

<style lang="scss" scoped>
.recordSKU {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }

  .formDialog {
    .el-select {
      width: 100%;
    }
  }
  .scope_img {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
